import { AfterContentInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, viewChild } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { VerfahrenLinkRel, VerfahrenResource } from '@schir-int-client/verfahren-shared';
import {
	loadVorgaengeByVerfahrenAction,
	loadVorgaengeByVerfahrenSuccessAction,
	setVorgangStatusSuccessAction,
	VorgangFacade,
	VorgangResource,
	VorgangStatus,
} from '@schir-int-client/vorgang-shared';
import { Spinner } from '@schir-int-client/tech';
import { Observable, Subscription } from 'rxjs';
import { ActionsSubject } from '@ngrx/store';
import { getIdNumber } from '../../../../test-helpers/src/lib/resource-helper';

@Component({
	selector: 'schir-int-client-vorgaenge-in-verfahren',
	templateUrl: './vorgaenge-in-verfahren.component.html',
	styleUrls: ['./vorgaenge-in-verfahren.component.scss'],
	standalone: false,
})
export class VorgaengeInVerfahrenComponent implements OnInit, OnChanges, AfterContentInit, OnDestroy {
	@Input() verfahren: VerfahrenResource;
	readonly spinnerRef = viewChild<ElementRef>('spinner');

	vorgaengeInVerfahren: Observable<VorgangResource[]>;
	standortAkte: string;
	readonly verfahrenLinkRel = VerfahrenLinkRel;

	private spinner: Spinner;
	private subscriptions: Subscription[] = [];

	constructor(
		private vorgangFacade: VorgangFacade,
		private actions: Actions,
		private actionListener: ActionsSubject
	) {}

	ngOnInit(): void {
		this.vorgaengeInVerfahren = this.vorgangFacade.getVorgaengeByVerfahren(this.verfahren);
		this.standortAkte = this.verfahren?.stammdaten?.standortAkte;

		/**
		 * TODO im Rahmen von SCHIFF-5196 entfernen. Wird aktuell hier statt im Effect vorgenommen, weil sonst Components und Effect ein Mehrfachladen verursachen würden
		 **/
		this.subscriptions.push(
			this.actionListener.pipe(ofType(setVorgangStatusSuccessAction)).subscribe(({ vorgang }) => {
				switch (vorgang.status) {
					case VorgangStatus.RUECKLAUF:
						this.vorgangFacade.loadVorgaengeInRuecklauf();
						break;
					case VorgangStatus.RECHTSPFLEGE:
						this.vorgangFacade.loadVorgaengeRechtspfleger();
						break;
					// case VorgangStatus.WIEDERVORLAGE: wird durch den vorgang.reducer behandelt, indem reload=true gesetzt wird
				}
			})
		);
	}

	ngOnChanges(): void {
		this.vorgaengeInVerfahren = this.vorgangFacade.getVorgaengeByVerfahren(this.verfahren);
		this.standortAkte = this.verfahren?.stammdaten?.standortAkte;
	}

	ngAfterContentInit() {
		this.spinner = new Spinner(
			this.actions,
			loadVorgaengeByVerfahrenAction.type,
			loadVorgaengeByVerfahrenSuccessAction.type,
			this.spinnerRef()
		);
	}

	ngOnDestroy() {
		this.spinner.destroy();
		this.subscriptions.forEach(s => s.unsubscribe());
	}

	get verfahrenId(): number {
		return getIdNumber(this.verfahren);
	}

	isSelected(vorgang: VorgangResource): Observable<boolean> {
		return this.vorgangFacade.isSelectedVorgang(vorgang);
	}

	setSelected(vorgang: VorgangResource) {
		this.vorgangFacade.setSelectedVorgang(vorgang);
	}

	updateNotiz(vorgang: VorgangResource, notiz: string) {
		this.vorgangFacade.updateNotiz(notiz, vorgang);
	}

	protected readonly linkRel = VerfahrenLinkRel;
}
